/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit
 */
export interface IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit {
    /**
     * 
     * @type {string}
     * @memberof IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit
     */
    name?: string;
}

/**
 * Check if a given object implements the IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit interface.
 */
export function instanceOfIntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitFromJSON(json: any): IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit {
    return IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitFromJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitToJSON(value?: IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

